import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import CourseShowModal from "./CourseShowModal";
import online from "../../images/landingPage/online.svg";
import HomeNavBar from "../components/HomeNavBar";
import { useSelector, useDispatch } from "react-redux";
import Footer from "../components/Footer";
import { searchByCourses } from "../../actions/home/home_action";
import { CartProvider, useCart } from "react-use-cart";
import { addElementToCart } from "../../actions/home/cart_action";
import FlashMessage from "react-flash-message";
import { Link } from "react-router-dom";

const HomeAllCourses = () => {
  const state = useSelector((state) => state.homeReducer);
  const [courseData, setCourseData] = useState({});
  const [courseModal, setCourseModal] = useState(false);
  const dispatch = useDispatch("");
  const [search, setSearch] = useState();
  const { addItem, inCart, setCartMetadata } = useCart();
  useEffect(() => {
    dispatch(searchByCourses({ search: search }));
  }, []);

  const courseContentData = (li) => {
    setCourseModal(true);
    setCourseData(li);
  };

  const resetCourseData = () => {
    setCourseModal(false);
    setCourseData({});
  };

  const searchCourse = () => {
    dispatch(searchByCourses({ search: search }));
  };

  const deviceKey = localStorage.getItem("uu");
  const addToCart = (data) => {
    dispatch(
      addElementToCart({
        type: "is_course",
        type_id: data.id,
        price: data.price,
        device_key: deviceKey,
      })
    );
  };

  return (
    <LoadingOverlay active={state.loading} spinner text="Loading...">
      <div className="main-landing-page traning-landing-page landing-container">
        {/* navbar */}
        <HomeNavBar />
        <div className="container-fluid">
          <div className="row cource-section">
            <div className="col-9">
              <div className="titlepage">
                <h1 className="color-white">Courses</h1>
              </div>
            </div>

            <div className="col-3">
              <div className="titlepage">
                <Link to={"/cart"} title={"View Cart"}>
                  <h4 className="color-white">View Cart</h4>
                  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 search-course">
              <input
                type="text"
                placeholder="Search Course"
                className="form-control serach-text-course sr-cert"
                onChange={(e) => {
                  setSearch(e.target.value);
                  if (e.target.value === "") {
                    dispatch(searchByCourses({ search: "" }));
                  }
                }}
              />
              <button
                className="btn-common sr-btn"
                type="button"
                onClick={() => searchCourse()}
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          {/*<FlashMessage duration={5000}>
            <strong>I will disapper in 5 seconds!</strong>
            </FlashMessage> */}

          <div className="row cource-section">
            {state.courses.map((li, i) => (
              <div className="col-lg-4 mb-3" key={i}>
                <div className="box">
                  <div className="row">
                    <div className="col-xs-12 col-12">
                      <h4 className="title certification-nm">
                        <span className="certification-nm">{li.name}</span>
                      </h4>
                      {/*<p className="course-count">10+ Courses</p>*/}
                    </div>
                    <br />
                    <div className="col-xs-6 col-6">
                      <h6 className="cer-details">Category</h6>
                      <h6 className="cer-details">{li.level}</h6>
                      <h6 className="cer-details">
                        {li.duration + " " + li.duration_type}
                      </h6>
                    </div>

                    <div className="col-xs-6 col-6 align-c">
                      <img className="" src={online} alt="First slide" />
                    </div>
                    
                    <div className="col-5">
                      <button
                        onClick={() => addToCart(li)}
                        className="btn-common"
                      >
                        Add to Cart
                      </button>
                    </div>
                    <div className="col-7  align-r">
                      <a
                        className="mr-14"
                        onClick={() => courseContentData(li)}
                      >
                        Course Content
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        </div>
        {/* footer */}
        <Footer />
      </div>
      {courseModal && (
        <CourseShowModal
          show={courseModal}
          courseData={courseData}
          handelCloseShow={() => resetCourseData()}
        />
      )}
    </LoadingOverlay>
  );
};

export default HomeAllCourses;
